<lib-page-container [title]="title" subtitle="View and manage all receipt submissions"
  [loading]="screen.isLoading()" [version]="appVersion.version" [apiVersion]="appVersion.apiVersion$ | async">
  <div lib-page-breadcrumbs>
    <lib-breadcrumbs></lib-breadcrumbs>
  </div>
  <!-- <div lib-page-actions>
    <lib-button (click)="grid.openFilters()" tooltip="Search receipt" icon="search">Search</lib-button>
  </div> -->
  <div lib-page-body>
    <div class="search-filters-container">
      <div class="filters-container">
        <div class="search-field modern-input">
            <input
                  placeholder="Search receipts..."
                  [(ngModel)]="searchText"
                  (input)="onSearchChange($event)"
                  class="search-input">
            <mat-icon class="search-icon">search</mat-icon>
            @if (searchText) {
              <button mat-icon-button (click)="clearSearch()" class="clear-btn">
                <mat-icon>close</mat-icon>
              </button>
            }
        </div>
        <button
          class="tags-filter-button"
          #tagsMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="tagsMenu"
          aria-label="Filter by tags">
          All Tags ({{ selectedTags?.length > 0 ? selectedTags.length : totalTagsCount }})
          <mat-icon>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #tagsMenu="matMenu">
          <div class="custom-dropdown tags-dropdown">
            <!-- Quick Actions -->
            <div class="quick-actions">
              <button mat-menu-item (click)="clearTags()">
                <span class="button-label button-dropdown-all-tags">Clear All Filters</span>
              </button>
            </div>

            <!-- Tag Checkboxes -->
            @for (tag of availableTags; track tag.value) {
              <div mat-menu-item class="tag-menu-item">
                <mat-checkbox
                  class="tag-checkbox"
                  color="primary"
                  [checked]="selectedTags?.includes(tag.value)"
                  (click)="$event.stopPropagation(); toggleTag(tag.value)">
                  <span class="tag-option">
                    <span class="tag-label" [title]="tag.label">{{ tag.label }}</span>
                    @if (tag.count !== undefined) {
                      <span class="tag-count">{{ tag.count }}</span>
                    }
                  </span>
                </mat-checkbox>
              </div>
            }
          </div>
        </mat-menu>

        <app-receipt-column-config></app-receipt-column-config>

        <button
          class="filter-fields-button"
          (click)="grid.openFilters()"
          aria-label="Filter by fields">
          Filter by fields
          <mat-icon>filter_list</mat-icon>
        </button>

        <div class="items-count">
          {{ totalItems }} items (showing {{ currentPageItems }})
        </div>
      </div>
    </div>

    <app-receipt-grid
      #grid
      (receiptSelected)="onReceiptSelected($event)"
      (rowHovered)="onReceiptRowHover($event)"
      (rowClicked)="onReceiptRowClick($event)"
      (rowCtrlClicked)="onReceiptCtrlClick($event)">
    </app-receipt-grid>

    <!-- Pagination Component -->
    <div class="pagination-container">
      <div class="pagination-info">
        <span>Showing {{ getShowingText() }} of {{ totalItems }} items</span>

        <!-- Page Size Selector -->
        <button
          class="page-size-button"
          #pageSizeMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="pageSizeMenu"
          aria-label="Items per page">
          {{ pageSize }} items
          <mat-icon>arrow_drop_down</mat-icon>
        </button>

        <mat-menu #pageSizeMenu="matMenu">
          @for (size of pageSizeOptions; track size) {
            <button mat-menu-item (click)="onPageSizeChange(size)">
              {{ size }} items
            </button>
          }
        </mat-menu>
      </div>

      <div class="pagination-controls">
        <button
          mat-button
          class="pagination-btn prev-btn"
          [disabled]="currentPage === 1"
          (click)="previousPage()">
          <mat-icon>chevron_left</mat-icon>
          Previous
        </button>

        <div class="page-numbers">
          @for (page of getVisiblePages(); track $index) {
            @if (page === '...') {
              <span class="page-ellipsis">...</span>
            } @else {
              <button
                mat-button
                class="page-btn"
                [class.active]="page === currentPage"
                (click)="goToPage(+page)">
                {{ page }}
              </button>
            }
          }
        </div>

        <button
          mat-button
          class="pagination-btn next-btn"
          [disabled]="currentPage === totalPages"
          (click)="nextPage()">
          Next
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>

    <!-- Keyboard Shortcuts Help -->
    <div class="keyboard-shortcuts-container">
      <div class="shortcuts-title">Keyboard Shortcuts</div>
      <div class="shortcuts-grid">
        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>↑</kbd>
            <kbd>↓</kbd>
          </span>
          <span class="shortcut-description">Navigate between receipts</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>←</kbd>
            <kbd>→</kbd>
          </span>
          <span class="shortcut-description">Navigate between campaign tabs</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>E</kbd>
          </span>
          <span class="shortcut-description">Mark as Eligible</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>T</kbd>
          </span>
          <span class="shortcut-description">Focus tags input</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>Enter</kbd>
          </span>
          <span class="shortcut-description">Open full receipt details</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>Esc</kbd>
          </span>
          <span class="shortcut-description">Close side panel / image modal</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>F</kbd>
          </span>
          <span class="shortcut-description">Mark as Fraud</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>R</kbd>
          </span>
          <span class="shortcut-description">Reject receipt</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>X</kbd>
          </span>
          <span class="shortcut-description">Expand/Collapse all receipts</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>Ctrl+Click</kbd>
          </span>
          <span class="shortcut-description">Open in new tab</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>S</kbd>
          </span>
          <span class="shortcut-description">Edit stamps received</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>L</kbd>
          </span>
          <span class="shortcut-description">Add new line item</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>P</kbd>
          </span>
          <span class="shortcut-description">Edit points received</span>
        </div>

        <div class="shortcut-item">
          <span class="shortcut-keys">
            <kbd>H</kbd>
          </span>
          <span class="shortcut-description">Open history details</span>
        </div>
      </div>
    </div>
  </div>
</lib-page-container>
